import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import confirmViewStateToProps from "../selectors";
import * as actions from "../actions";
import ConfirmLayout from "./ConfirmLayout";

const fileShape = PropTypes.shape({
  filename: PropTypes.string.isRequired,
  soloFilePk: PropTypes.number.isRequired,
  numCasts: PropTypes.number,
  annotatedDate: PropTypes.string,
  collectionDt: PropTypes.string
});

function ConfirmView(props) {
  useEffect(() => {
    document.title = "Solo Confirm";
    props.actions.updateFiltersFromQuery(props.location.search);
    props.actions.soloConfirmFilesFetchIfNeeded();
  }, []);

  useEffect(() => {
    props.actions.updateFiltersFromQuery(props.location.search);
    props.actions.soloConfirmFilesFetchIfNeeded();
  }, [props.workarea]);

  function handleFilesRefreshClick() {
    props.actions.soloConfirmFilesInvalidate();
    props.actions.soloConfirmFilesFetchIfNeeded();
  }

  function handleFindFilesClick() {
    props.actions.soloConfirmFilesInvalidate();
    props.actions.soloConfirmFilesFetchIfNeeded();
  }

  function handleClearForm() {
    props.actions.clearSoloFilters();
  }

  function handleFilesTableRowSelect(rowIndex) {
    const { soloFilePk } = props.soloConfirmFilesList[rowIndex];
    if (props.soloFilesBeingConfirmed.includes(soloFilePk)) {
      props.actions.soloRemoveFileToConfirm({ soloFilePk });
    } else {
      props.actions.soloAddFileToConfirm({ soloFilePk });
      props.actions.soloConfirmCastsFetchIfNeeded({ soloFilePk });
    }
  }

  function handleToggleRecallClick(soloFilePk) {
    if (props.soloFilesToRecall.includes(soloFilePk)) {
      props.actions.soloRemoveFileToRecall({ soloFilePk });
    } else {
      props.actions.soloAddFileToRecall({ soloFilePk });
    }
  }

  function handleRecallFilesClick() {
    props.actions.soloRecallFiles();
  }

  return (
    <ConfirmLayout
      {...props}
      onSoloConfirmStartDateFilterChange={e =>
        props.actions.setSoloConfirmStartDateFilter(e)
      }
      onSoloConfirmEndDateFilterChange={e =>
        props.actions.setSoloConfirmEndDateFilter(e)
      }
      onSoloConfirmInstrumentNumFilterChange={e =>
        props.actions.setSoloConfirmInstrumentNumFilter(e.target.value)
      }
      onFilesRefreshClick={() => handleFilesRefreshClick()}
      onFilesTableRowSelect={(e, rowIndex) =>
        handleFilesTableRowSelect(rowIndex)
      }
      onToggleRecallClick={soloFilePk => handleToggleRecallClick(soloFilePk)}
      onRecallFilesClick={() => handleRecallFilesClick()}
      onFindFilesClick={() => handleFindFilesClick()}
      onClearForm={() => handleClearForm()}
    />
  );
}

ConfirmView.propTypes = {
  workarea: PropTypes.string,
  organization: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  soloConfirmFilesList: PropTypes.arrayOf(fileShape).isRequired,
  soloFilesBeingConfirmed: PropTypes.arrayOf(PropTypes.number),
  soloFilesToRecall: PropTypes.arrayOf(PropTypes.number),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  actions: PropTypes.shape({
    setSoloConfirmStartDateFilter: PropTypes.func.isRequired,
    setSoloConfirmEndDateFilter: PropTypes.func.isRequired,
    setSoloConfirmInstrumentNumFilter: PropTypes.func.isRequired,
    soloConfirmFilesInvalidate: PropTypes.func.isRequired,
    soloConfirmFilesFetchIfNeeded: PropTypes.func.isRequired,
    soloRemoveFileToConfirm: PropTypes.func.isRequired,
    soloAddFileToConfirm: PropTypes.func.isRequired,
    soloConfirmCastsFetchIfNeeded: PropTypes.func.isRequired,
    soloAddFileToRecall: PropTypes.func.isRequired,
    soloRemoveFileToRecall: PropTypes.func.isRequired,
    soloRecallFiles: PropTypes.func.isRequired,
    clearSoloFilters: PropTypes.func.isRequired,
    updateFiltersFromQuery: PropTypes.func.isRequired
  }).isRequired
};

ConfirmView.defaultProps = {
  workarea: null,
  organization: null,
  // eslint-disable-next-line react/default-props-match-prop-types
  soloConfirmFilesList: [],
  soloFilesBeingConfirmed: [],
  soloFilesToRecall: []
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(confirmViewStateToProps, mapDispatchToProps)(ConfirmView)
);
